const optionsComponent = require('../optionsComponent/optionsComponent');

// selectButtons — client JS for selectButtons.tpl, an alternate template of the
// SELECT component that renders the options as toggle buttons.
//
// Extends optionsComponent (the common base of select/selectMultiple), NOT select,
// because the button-group UI has nothing in common with select's dropdown markup;
// it only needs optionsComponent's dependable filtering. this.element is the hidden
// input (carries the submittable name + value); each option button is a 'button'
// subelement. Single-select / radio-style: selectedValue is one option id, exactly
// one button is active at a time, and selecting drives the stock dependable filtering
// so dependants react live (a null 'all' option whose value is the '__any__' wildcard
// shows every dependant — see filterHideAction).
const selectButtons = Object.assign({}, optionsComponent, {
    // Collected by component.initSubelements(); declared as an array so every button
    // element with data-zit-subelement-type="button" is pushed in.
    subelements: {
        button: []
    },
    selectedValue: null,

    init: function () {
        optionsComponent.init.call(this);

        // data-zit-selected-value arrives as a single option id; keep it a string so
        // comparisons against the buttons' data-zit-value (always strings) are exact.
        this.selectedValue = String(this.selectedValue);

        // Select on click. Nothing is disabled for read-only instances — the UI stays
        // interactive; persistence is prevented server-side instead.
        this.subelements.button.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectButton(button);
            });
        });
    },

    // The single selected option id. Honours a filter-driven hidden value the same way
    // the other options components do.
    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        return this.selectedValue;
    },

    // Make the clicked button the only active one (radio behaviour): clear the
    // previously active button, activate this one, sync the hidden input, then re-run
    // dependable filtering. Clicking the already-active button is a no-op — there is
    // always exactly one selection, and the 'all' option is how the user resets it.
    selectButton: function (button) {
        let optionId = button.dataset.zitValue;

        if (optionId === this.selectedValue) {
            return;
        }

        // The runtime selection token; must equal the buttonSelected zone the template
        // rendered for the initial state (see selectButtons.tpl header).
        let activeClass = this.hm.behaviors.activation.stateClass('active');
        let activeTokens = activeClass.split(' ');

        // clear the previously-active button
        this.subelements.button.forEach((otherButton) => {
            if (otherButton.dataset.zitValue === this.selectedValue) {
                otherButton.classList.remove(...activeTokens);
            }
        });

        // activate the clicked one and record the selection
        button.classList.add(...activeTokens);
        this.selectedValue = optionId;

        // keep the hidden input's value consistent with the selection
        this.element.value = this.selectedValue;

        // drive dependant components (no-op unless a parentAttribute is configured)
        this.filterDependables();
    }
});

module.exports = selectButtons;
